import PropTypes from 'prop-types';

TextArea.propTypes = {
  labelText: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  fieldName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  currentValue: PropTypes.string,
};
export default function TextArea({
  labelText,
  placeholder = '',
  fieldName,
  onChange,
  className = '',
  currentValue = '',
}) {
  return (
    <label className={`form-control ${className}`}>
      <div className="label">
        <span className="label-text">{labelText}</span>
      </div>
      <textarea
        className="textarea textarea-bordered h-24"
        placeholder={placeholder}
        name={fieldName}
        onChange={onChange}
      >
        {currentValue}
      </textarea>
    </label>
  );
}
